module.exports = __webpack_public_path__ + "static/media/fuel_run.a445f650.svg";